// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../../../styles/helpers.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__sectionTitle___d6zAk {
}

.styles__singleLine___r7GR3 {
  display: flex;
  width: 100%;
  height: 48px;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  padding: 0 16px;
  border-bottom: 0.5px solid #e0e0e0;
}

.styles__singleLine___r7GR3:last-child {
  border-bottom: none;
}

.styles__label___Z_b_4 {
  padding: 0 10px;
  opacity: 0.9;
  cursor: pointer;
  font-size: 14px;
  color: #666666;
}

.styles__singleLine___r7GR3 div.styles__label___Z_b_4:nth-child(1) {
  text-align: left;
  margin-left: 9px;
}

.styles__singleLine___r7GR3 div.styles__label___Z_b_4:nth-child(2) {
  text-align: right;
  margin-right: 5px;
}

.styles__accordionContainer___xDhoe {
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./universal/routes/Protected/Account/components/Number/Subaccounts/AssetServicesAccordion/styles.css"],"names":[],"mappings":"AAEA;AAEA;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb","sourcesContent":["@value helpers: \"styles/helpers.css\";\n\n.sectionTitle {\n  composes: sectionTitle from helpers;\n}\n\n.singleLine {\n  display: flex;\n  width: 100%;\n  height: 48px;\n  align-items: center;\n  flex-direction: row;\n  justify-content: space-between;\n  padding: 0 16px;\n  border-bottom: 0.5px solid #e0e0e0;\n}\n\n.singleLine:last-child {\n  border-bottom: none;\n}\n\n.label {\n  padding: 0 10px;\n  opacity: 0.9;\n  cursor: pointer;\n  font-size: 14px;\n  color: #666666;\n}\n\n.singleLine div.label:nth-child(1) {\n  text-align: left;\n  margin-left: 9px;\n}\n\n.singleLine div.label:nth-child(2) {\n  text-align: right;\n  margin-right: 5px;\n}\n\n.accordionContainer {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"helpers": `"styles/helpers.css"`,
	"sectionTitle": `styles__sectionTitle___d6zAk ${___CSS_LOADER_ICSS_IMPORT_0___.locals["sectionTitle"]}`,
	"singleLine": `styles__singleLine___r7GR3`,
	"label": `styles__label___Z_b_4`,
	"accordionContainer": `styles__accordionContainer___xDhoe`
};
export default ___CSS_LOADER_EXPORT___;
